<miq-filter-bar-label [props]="props()"></miq-filter-bar-label>

<mat-form-field appearance="outline" class="equals-filter-field">
  <input
    matInput
    autocomplete="no-autofill"
    [placeholder]="props()?.placeholder"
    [formControl]="control"
    aria-label="props.name"
    class="equals-filter-input"
    (change)="doSearch($event)"
    (keydown.enter)="doSearch($event)"
  />
</mat-form-field>
